import ApiService from './api.service';

export const ModelEComplianceMetricAnswerPersonService = {
  index(params) {
    return ApiService.query('model_e/compliance_metric_answer_people', {
      params,
    });
  },
  show(slug) {
    return ApiService.get('model_e/compliance_metric_answer_people', slug);
  },
  create(params) {
    return ApiService.post('model_e/compliance_metric_answer_people', {
      data: params,
    });
  },
  update(slug, params) {
    return ApiService.update('model_e/compliance_metric_answer_people', slug, {
      data: params,
    });
  },
  destroy(slug) {
    return ApiService.delete('model_e/compliance_metric_answer_people', slug);
  },
};

export default ModelEComplianceMetricAnswerPersonService;
